import api from '@shared/services/api';

/**
 * Service for handling message notifications
 */
export class MessageNotificationsService {
  /**
   * Send consolidated message notifications
   * @param conversationId - ID of the conversation
   * @param recipientIds - Array of recipient IDs
   * @param messages - Array of unsent messages
   * @returns Promise with the response
   */
  static async sendConsolidatedNotifications(
    conversationId: string,
    recipientIds: string[],
    messages: any[]
  ) {
    try {
      const response = await api.post('/notifications/messages', {
        conversationId,
        recipientIds,
        messages,
      });
      return response.data;
    } catch (error) {
      console.error('Error sending consolidated message notifications:', error);
      throw error;
    }
  }
}
